import { EntryMethod } from 'components/enter/EntryMethod';
import GenericModal from 'components/GenericModal';
import RoundedButton from 'components/RoundedButton';
import Link from 'next/link';
import { formattedJackpotBoostCost } from 'utils/common';
import { ASSET_PREFIX, SubscriberStatus } from 'utils/constants';

interface IBoostJackpotPopupProps {
  entryMethod: keyof typeof EntryMethod|undefined;
  boostCostPerEntry: number;
  subscriberStatus?: keyof typeof SubscriberStatus;
  onClose: () => void;
  ctaText?: string;
  ctaOnClick?: () => void;
}

const BoostJackpotPopup = ({
  entryMethod,
  boostCostPerEntry,
  subscriberStatus,
  onClose,
  ctaText,
  ctaOnClick,
}: IBoostJackpotPopupProps) => {
  const showLiteCopy =
    entryMethod === EntryMethod.LiteSubscription ||
    subscriberStatus === SubscriberStatus.LITE;
  const showFreemiumCopy = subscriberStatus === SubscriberStatus.FREEMIUM;

  const formattedBoostCostPerEntry = formattedJackpotBoostCost(
    boostCostPerEntry * 100
  );

  return (
    <GenericModal onClose={onClose}>
      <img
        src={`${ASSET_PREFIX}/images/enter/boost-win-popup-icon.png`}
        className="icon"
        alt=""
      />

      <h4>
        Boost your win
        {entryMethod === 'FreeSubscription' && (
          <>
            <br />
            with DAYMADE Premium and Lite
          </>
        )}
      </h4>

      {showFreemiumCopy ? (
        <p>
          When you upgrade to Lite or Premium, you can choose to boost your
          jackpot for an extra {formattedBoostCostPerEntry} per entry and be in
          with a chance of winning a jackpot prize worth £100,000! To win, you
          need to match all 4 main numbers plus the bonus ball.
        </p>
      ) : (
        <p>
          If you choose to boost your jackpot for {formattedBoostCostPerEntry}{' '}
          per entry, we will{' '}
          {showLiteCopy
            ? '10x your jackpot value from £10,000 to £100,000'
            : '4x your jackpot value from £25,000 to £100,000'}
          . For our range of £100,000 prizes, check out our{' '}
          <Link href={`/prizes?tier=DAYMAKERboost`}>
            <a
              target="_blank"
              style={{
                textDecoration: 'underline',
                whiteSpace: 'break-spaces',
              }}
            >
              DAYMAKERboost prize listings
            </a>
          </Link>
          ! To win, you need to match all 4 main numbers plus the bonus ball.
        </p>
      )}

      <p>You can opt-out of your boost at any time – no strings attached!</p>

      <RoundedButton
        onClick={ctaOnClick || onClose}
        style={{
          width: 'calc(100% - 3em)',
          marginTop: '2em',
        }}
      >
        {ctaText || 'Got It'}
      </RoundedButton>

      <style jsx>
        {`
          .icon {
            width: 100px;
            height: 100px;
          }

          h4 {
            letter-spacing: normal;
            text-transform: none;
            font-weight: 800;
            font-size: 1.2rem;
          }
        `}
      </style>
    </GenericModal>
  );
};

export default BoostJackpotPopup;
